module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Resolution":"Resolution","Select a resolution":"Select a resolution","Frame Rate(fps)":"Frame Rate(fps)","Select a frame rate":"Select a frame rate","Bitrate(kbps)":"Bitrate(kbps)","Mirror":"Mirror"},"zh":{"Resolution":"分辨率","Select a resolution":"请选择分辨率","Frame Rate(fps)":"帧率(fps)","Select a frame rate":"请选择帧率","Bitrate(kbps)":"码率(kbps)","Mirror":"翻转镜像"}}')
  delete Component.options._Ctor
}
